import { useState } from "react";

export function useBoolState(defaultValue: boolean = false) {
    const [state, setState] = useState<boolean>(defaultValue);

    const enable = () => setState(true);
    const disable = () => setState(false);
    const toggle = () => setState(prev => !prev);

    return {
        value: state,
        enable,
        disable,
        toggle
    }
}